import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import upperFirst from "lodash/upperFirst";
import { Select } from "@whatslly/ui-components/v2/BaseElements/Select";
import { useDependencyInjector } from "@whatslly/commons/di";
import { DestinationsStore } from "../../DestinationsStore";
import { observer } from "mobx-react-lite";
import { useField } from "formik";

export const AuditLogNamespaceSelect: React.FC<{ name: string }> = observer(({ name }) => {
  const { t } = useTranslation();
  const destinationsStore = useDependencyInjector(DestinationsStore);
  const [field, , helpers] = useField<string[] | undefined>(name);

  const options = useMemo(
    () =>
      destinationsStore.listOfAuditNamespaces.map((namespace) => ({
        label: upperFirst(t(`audit_log.namespaces.${namespace.const}`)),
        value: namespace.const,
      })),
    [destinationsStore.listOfAuditNamespaces, t]
  );

  const value = useMemo(() => options.filter((option) => field.value?.includes(option.value)), [options, field.value]);

  return (
    <Select
      ignoreMenuDirection
      isSearchable
      name={name}
      paddingInline="none"
      options={options}
      isClearable={false}
      isMulti
      placeholder={t("destinations_page.all_types")}
      value={value}
      onChange={(selected: { label: string; value: string }[]) => helpers.setValue(selected.map((option) => option.value))}
    />
  );
});
